import { inject, Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";

type ToastType = "success" | "info" | "warning" | "error";

const SNACKBAR_CSS_CLASS = "snackbar-custom";

@Injectable({
    providedIn: "root",
})
export class ToastService {
    static DEFAULT_DURATION = 10_000;

    private readonly _snackBar = inject(MatSnackBar);
    private readonly translateService = inject(TranslateService);

    success(
        message: string,
        duration: number = ToastService.DEFAULT_DURATION,
    ) {
        this.openToast(message, "success", duration);
    }

    info(
        message: string,
        duration: number = ToastService.DEFAULT_DURATION,
    ) {
        this.openToast(message, "info", duration);
    }

    warning(
        message: string,
        duration: number = ToastService.DEFAULT_DURATION,
    ) {
        this.openToast(message, "warning", duration);
    }

    error(
        message: string,
        duration: number = ToastService.DEFAULT_DURATION,
    ) {
        this.openToast(message, "error", duration);
    }

    private openToast(message: string, type: ToastType, duration?: number) {
        const translation = this.translateService.instant(message);
        this._snackBar.open(translation, "OK", {
            duration,
            verticalPosition: "top",
            panelClass: [SNACKBAR_CSS_CLASS, `toast-${type}`],
        });
    }
}
